import { useState } from 'react';

export const useModel = (model, params = {}, env = {}) => {
  const [state] = useState(() => model.create(params, env));
  return state;
};
